// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"6639a4ca","453":"1e01214f"}[chunkId] + ".chunk.js";
};